const StrCompanyDirectory = () => {
  return (
    <div>
      <p>Annuaire société sous-traitante page</p>
    </div>
  );
};

export default StrCompanyDirectory;
